export default "__VITE_ASSET__4xguvouh__"